<section class="h-100">
  <div class="container-fluid py-2 h-100">
    <div class="row d-flex h-100">
      <div class="col">
        <div class="card">
          <div class="card-body p-xl-4">
            <div class="row">
              <div class="col-12">
                <h2 class="pb-2">
                  <em class="fas fa-shopping-cart"></em>
                  {{ 'Warenkorb' | translate }}
                </h2>
                @if (supplierBaskets && supplierBaskets.length) {
                  @for (supplier of supplierBaskets; track supplier) {
                    @for (basketItem of supplier?.basketItems; track basketItem) {
                      <div class="card mb-3">
                        <div class="card-body p-2">
                          <div>
                            @if (basketItem.product.supplierProductNumber) {
                              <p class="d-flex justify-content-between">
                                <strong>
                                  {{ 'Artikelnummer Lieferant' | translate }}:
                                </strong>
                                <span>
                                  {{ basketItem.product.supplierProductNumber }}
                                </span>
                              </p>
                            }
                          </div>
                          <div class="row">
                            <div class="col-xl-6 col-lg-8 col-md-8 col-sm-8 col-10 order-1">
                              <div>
                                <h5 class="font-11">
                                  {{ basketItem.product.name }}
                                </h5>
                                @if (basketItem.quantity.unit) {
                                  <p
                                    class="small mb-0 d-block"
                                    >
                                    {{ basketItem.quantity.value }}
                                    {{
                                    basketItem.quantity.unit
                                    | unit: basketItem.quantity.value
                                    }}
                                  </p>
                                }
                                @if (!basketItem.quantity) {
                                  <em
                                    class="fas fa-exclamation-triangle text-danger"
                                                                [matTooltip]="
                                                                    'Keine Angaben über die Einheit vorhanden!'
                                                                        | translate
                                                                "
                                  ></em>
                                }
                              </div>
                            </div>
                            <div
                              class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-12 order-xl-2 order-lg-2 order-md-2 order-sm-2 order-3 d-flex justify-content-end align-items-end align-items-xl-center justify-content-xl-center align-items-lg-center justify-content-lg-center align-items-md-center justify-content-md-center align-items-sm-center justify-content-sm-center flex-column"
                              >
                              <div>
                                <h6 class="mb-0">
                                  <display-currency [value]="basketItem.price.amount" [currencyCode]="basketItem.price.currency" />
                                </h6>
                              </div>
                            </div>
                            @if (basketItem.product.type !== catalogType.FREIGHT_COST) {
                              <div
                                class="col-xl-2 col-lg-1 col-md-1 col-sm-1 col-2 order-xl-3 order-lg-3 order-md-3 order-sm-3 order-2 d-flex justify-content-center align-items-center"
                                >
                                <a
                                  class="text-danger pl-1"
                                  type="button"
                                  (click)="deleteItem(basketItem, supplier.id)"
                                  >
                                  <i class="fas fa-trash-alt"></i>
                                </a>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  }
                  <hr class="basket-sidenav__line" />
                  <fieldset class="border rounded-3 p-3">
                    <legend class="text-primary basket-sidenav__total-title float-none w-auto px-3">
                      {{ 'Zusammenfassung' | translate }}
                    </legend>
                    @for (currencyTotal of basket.currencyTotals; track $index) {
                      <div class="mt-4">
                        @if (currencyTotal.netTotal) {
                          <div
                            class="row justify-content-center align-items-center"
                            >
                            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12">
                              <strong class="text-primary">
                                {{ 'Summe netto' | translate }}
                              </strong>
                            </div>
                            <div
                              class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 d-flex justify-content-end"
                              >
                              <strong>
                                <display-currency [value]="currencyTotal.netTotal.amount" [currencyCode]="currencyTotal.netTotal.currency" />
                              </strong>
                            </div>
                          </div>
                        }
                        <div class="row justify-content-center align-items-center">
                          <div
                            class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 d-flex flex-column"
                            >
                            @for (tax of currencyTotal.taxBreakdown; track $index) {
                              <strong>
                                {{
                                'zzgl. \{\{value\}\}% MwSt.'
                                | translate: { value: tax.taxRate }
                                }}
                              </strong>
                            }
                          </div>
                          <div
                            class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 d-flex justify-content-end flex-column align-items-end"
                            >
                            @for (tax of currencyTotal.taxBreakdown; track $index) {
                              <strong>
                                <display-currency [value]="tax.totalAmount.amount" [currencyCode]="tax.totalAmount.currency" />
                              </strong>
                            }
                          </div>
                        </div>
                        <hr />
                        <div class="row justify-content-center align-items-center">
                          <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12">
                            <strong class="font-12 text-primary">
                              {{ 'Summe brutto' | translate }}
                            </strong>
                          </div>
                          <div
                            class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 d-flex justify-content-end"
                            >
                            <strong class="font-12">
                              <display-currency [value]="currencyTotal?.grossTotal?.amount" [currencyCode]="currencyTotal?.grossTotal?.currency" />
                            </strong>
                          </div>
                        </div>
                      </div>
                    }
                  </fieldset>
                  <div class="row mt-3">
                    <div class="col">
                      <button class="btn btn-primary w-100" (click)="navigateToBasket()">
                        {{ 'zum Warenkorb' | translate }}
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="row">
                    <div class="col mx-2 alert alert-info mb-2">
                      {{ 'Es befinden sich keine Produkte im Warenkorb' | translate }}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
